import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  height: 48px;
  padding-right: 30px;
  background: #f0f1f2;
  cursor: pointer;
  user-select: none;

  &:hover {
    background: #2e579c;
  }
`;

export const DoubleArrow = styled.img`
  width: 13px;
  height: 16px;
`;

